import { useNavigate } from "react-router-dom";
import { useSecurity } from "../../../api/settings/security";
import { AppLayout } from "../../../layout/AppLayout";
import { motion } from "framer-motion";
import { Arrow } from "../../svg/Wallet/Wallet";
import { Card } from "../../Card";
import { CustomPinInput } from "../../input/CustomPinInput";
import Button from "../../button/Button";
import { Loader } from "../../loader/Loader";
import { UserContext } from "../../context/UseContext";
import { useContext } from "react";
import clsx from "clsx";

function TransactionPin() {
  const navigate = useNavigate();
  const { pin, setPin, handleSetPin, loading, handleGetOtp, gettingOtp } =
    useSecurity();
  const { profile } = useContext(UserContext);

  const handleCallGetOtp = async () => {
    const success = await handleGetOtp();
    if (success) {
      navigate("/settings/secure/transaction-pin/forgot");
    }
  };
  // const [show, setShow] = useState(false);
  // const [isChangePin, setIsChangePin] = useState(false);
  // const [newPin, setNewPin] = useState(false);
  // const [oldPin, setOldPin] = useState(false);
  // const [otp, setOtp] = useState(false);
  // const [confirmPin, setConfrimPin] = useState(false);
  // const isValid = pin.length === 4;

  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-10 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Transaction pin</p>
          </div>
          {profile.pin === null || profile.pin === "null" ? (
            <div className="mt-8">
              <Card>
                <div>
                  <p className="text-sm text-primary-black mb-3.5 font-normal">
                    Pin
                  </p>
                  <CustomPinInput autoFocus pin={pin} onPinChange={setPin} />
                </div>
              </Card>
              <div className="mt-8">
                <Button
                  disabled={pin.length === 4 ? false : true}
                  onClick={handleSetPin}
                  text={loading ? <Loader type="bubbles" /> : "Set Pin"}
                  className={loading && "!py-0"}
                />
              </div>
            </div>
          ) : (
            <div className="mt-8">
              <Card>
                <div>
                  <p className="text-sm text-primary-black mb-3.5 font-normal">
                    Pin
                  </p>
                  <CustomPinInput disabled pin={"****"} />
                </div>
              </Card>
              <div className="mt-8">
                <Button
                  text="Change Pin"
                  onClick={() =>
                    navigate("/settings/secure/transaction-pin/change")
                  }
                />
                <Button
                  text={gettingOtp ? <Loader type="bubbles" /> : "Forgot Pin"}
                  className={clsx(
                    gettingOtp && "!py-0",
                    "mt-5 !rounded-[50px] button_cancel !text-[#B4B4B4] !shadow-none"
                  )}
                  onClick={handleCallGetOtp}
                />
              </div>
            </div>
          )}
        </motion.div>
      </div>
      {/* <>
      {isChangePin && (
        <FullModal
          className={clsx(
            " fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto "
          )}
          onClose={() => setIsChangePin(false)}
          showCloseIcon={true}
          iconClass="!text-primary-black"
        >
          <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
            <div className="relative flex items-center justify-center mb-10 font-bold text-xl text-black">
              Change pin
            </div>

            <Card>
              <div className="mb-4">
                <p className="text-sm text-primary-black mb-3.5 font-normal">
                  Old pin
                </p>
                <CustomPinInput
                  pin={oldPin}
                  onPinChange={setOldPin}
                  autoFocus={true}
                />
              </div>
              <div className="mb-4">
                <p className="text-sm text-primary-black mb-3.5 font-normal">
                  New pin
                </p>
                <CustomPinInput
                  pin={newPin}
                  onPinChange={setNewPin}
                  autoFocus={true}
                />
              </div>
              <div>
                <p className="text-sm text-primary-black mb-3.5 font-normal">
                  Confirm pin
                </p>
                <CustomPinInput
                  pin={confirmPin}
                  onPinChange={setConfrimPin}
                  autoFocus={true}
                />
              </div>
            </Card>
            <Button
              onClick={() => setIsChangePin(false)}
              text="Confrim"
              className="!py-4 !mt-7 !rounded-[50px]"
            />
          </div>
        </FullModal>
      )}
      {show && (
        <FullModal
          className={clsx(
            " fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto "
          )}
          onClose={() => setShow(false)}
          showCloseIcon={true}
          iconClass="!text-primary-black"
        >
          <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
            <div className="relative flex items-center justify-center mb-10 font-bold text-xl text-black">
              Set transaction pin
            </div>

            <Card className="mb-5">
              <p className="text-primary-black text-sm font-normal text-center ">
                Enter the OTP sent to{" "}
                <span className="font-medium">+2348120207511</span>
              </p>
              <OTPInput getPin={(val) => setOtp(val)} />
              <div className="flex items-center justify-between mt-5">
                <div className="flex items-center gap-1.5">
                  <Check />
                  <p className="text-xs text-black">Code verified</p>
                </div>
                <button className="text-primary-main text-xs">
                  Resend OTP
                </button>
              </div>
            </Card>

            <Card>
              <div className="mb-4">
                <p className="text-sm text-primary-black mb-3.5 font-normal">
                  New pin
                </p>
                <CustomPinInput
                  pin={newPin}
                  onPinChange={setNewPin}
                  autoFocus={true}
                />
              </div>
              <div>
                <p className="text-sm text-primary-black mb-3.5 font-normal">
                  Confirm pin
                </p>
                <CustomPinInput
                  pin={confirmPin}
                  onPinChange={setConfrimPin}
                  autoFocus={true}
                />
              </div>
            </Card>
            <Button
              onClick={() => setShow(false)}
              text="Confrim"
              className="!py-4 !mt-7 !rounded-[50px]"
            />
          </div>
        </FullModal>
      )}
      </> */}
    </AppLayout>
  );
}

export default TransactionPin;
